<new-video-customer-modal
  *ngIf="showNewVideoCustomerModal"
  (close)="dismissNewVideoCustomerModal()"
  (newRequest)="navigateToNewVideoRequest()"
></new-video-customer-modal>

<header-left-nav-layout [showSidebar]="showSidebar">
  <div sidenav>
    <customers-nav></customers-nav>
  </div>

  <div main>
    <div class="container-fluid mt-3">
      <subscription-header
        *ngIf="customer"
        [customer]="customer"
        [currentUser]="currentUser">
      </subscription-header>
    </div>

    <div *ngIf="(!isSubmissionUI || customer?.multipass) && !isEditspace" class="container-fluid my-3">
      <ad-banner
        *ngIf="showBanner"
        mainTitle="<h5>Need blog topics?</h5>"
        subtitle="Get 10 blog topic ideas quickly from our Inbound-certified experts."
        actionButtonLabel="Learn More"
        [buttonEnabled]="canPurchaseTenTopics"
        icon="far fa-lightbulb"
        (actionClick)="onOpenPurchaseTopicsModal()">
      </ad-banner>
      <p class="small text-center" *ngIf="!canPurchaseTenTopics">You last requested ideas on {{lastTenTopicsPurchaseDate.format('MM/DD')}}—please check back under ‘Topic Ideas' on {{checkBackDate.format('MM/DD')}} to review.</p>
    </div>

    <div *ngIf="isSubmissionUI && !customer?.multipass" class="container-fluid my-3">
      <video-info-modal *ngIf="modalVisible" (close)="modalVisible = false" [price]="prettyPrice(videoPrice)"></video-info-modal>
      <div *ngIf="showVideoBanner">
        <ad-banner
          [mainTitle]="videoBannerTitle(prettyPrice(videoPrice))"
          subtitle="Get a teaser or summary video for any content you purchase."
          actionButtonLabel="Learn more"
          icon="fas fa-video"
          (actionClick)="modalVisible = true;">
        </ad-banner>
      </div>
    </div>

    <div class="text-center mt-4 mb-3 border-bottom">
      <post-tabs
        *ngIf="customer && account && currentUser && currentUser.canPurchasePosts"
        [customer]="customer"
        [account]="account"
        [currentUser]="currentUser"
      ></post-tabs>
    </div>

    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </div>
</header-left-nav-layout>
